/**
 *
 * VehicleWidget
 *
 */

import React from 'react';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';

//temporary placeholder for internationalization
export function lbl(str) {
  if (!str) return '';
  return <FormattedMessage id={str} defaultMessage={str.split?.('.').pop()} />;
}

export function lblStr(str) {
  return <FormattedHTMLMessage id={str} defaultMessage={str.split?.('.').pop()} />;
}
